



































































import { IControlElements } from "@/components/utility/TableWrapper.vue";
import Tooltip from "@/components/utility/tooltip.vue";
import PaginatedTable from "@/components/utility/v2/PaginatedTable.vue";
import TheLayoutPortal from "@/layouts/TheLayoutPortal.vue";
import { MessageFolderEnum } from "@/lib/enum/message-folder.enum";
import { ITableWrapperHeader } from "@/lib/types/tableWrapper";
import { copyToClipboard } from "@/lib/utility/copy-to-clipboard.helper";
import { PageFilterOperationEnum } from "@/lib/utility/data/page-filter-operation.enum";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { $t } from "@/lib/utility/t";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { BackendResourceEnum, ResourceEnum } from "@/store/enum/authResourceEnum";
import { PartnerTypeEnum } from "@/store/enum/partner/partner.type.enum";
import { AllMessagesModule } from "@/store/modules/all-messages.store";
import { PartnerModule } from "@/store/modules/partner";
import { IPageFilterElement, PageFilterElement } from "@/models/page-filter-element.entity";
import { IPartnerMessage } from "@/models/partner-message.entity";
import { IReference } from "@/models/reference.entity";
import { MrfiktivPartnerMessageControllerFindAllByPartnerIdParamsGen } from "@/services/mrfiktiv/v1/data-contracts";
import { PaginatedBaseStore } from "@/store/paginated-base.store";
import { Component, Prop, Vue } from "vue-property-decorator";
import ConfirmActionDialog from "../utility/ConfirmActionDialog.vue";
import MTextField from "../utility/mmmint/MTextField.vue";
import SideCard from "../utility/SideCard.vue";

@Component({
  components: {
    Tooltip,
    TheLayoutPortal,
    PaginatedTable,
    SideCard,
    PartnerMessageDetail: () => import("@/components/partner/PartnerMessageDetail.vue"),
    ConfirmActionDialog,
    MTextField
  },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class PartnerMessageTable extends Vue {
  readonly copyToClipboard = copyToClipboard;

  @Prop({ default: false })
  load!: boolean;

  @Prop({ default: () => [] })
  refs!: IReference[];

  @Prop({ default: () => [] })
  filters!: IPageFilterElement[];

  @Prop({ required: false })
  store!: PaginatedBaseStore<IPartnerMessage, MrfiktivPartnerMessageControllerFindAllByPartnerIdParamsGen>;

  selectedDocument: IPartnerMessage | null = null;

  MessageFolderEnum = MessageFolderEnum;
  ActionEnum = ActionEnum;
  ResourceEnum = ResourceEnum;
  PartnerTypeEnum = PartnerTypeEnum;

  isLoadingAll = false;
  isLoading = false;

  isDeleteDialogActive = false;
  isDeleteDialogLoading = false;

  search = "";

  itemsPerPage = 25;

  get localStore() {
    if (this.store) {
      return this.store;
    }

    return AllMessagesModule;
  }

  get headers(): ITableWrapperHeader[] {
    const headers: ITableWrapperHeader[] = [
      { text: $t("sign.DocumentTable.created"), align: "start", width: "120px", value: "timestamp.created" },
      { text: $t("components.PartnerMessageListPaginated.title"), align: "start", value: "folder", width: 80 }
    ];

    headers.push(
      { text: $t("sign.SignRequestForm.receiver"), align: "start", width: 350, value: "from" },
      { text: $t("components.template.detail.body.subject"), align: "start", value: "content.subject" },
      { text: "", align: "end", value: "controls", width: 120, sortable: false }
    );

    return headers;
  }

  beforeMount() {
    const filters: IPageFilterElement[] = [...(this.filters ?? [])];
    if (this.refs) {
      this.refs.forEach(ref => {
        filters.push(
          new PageFilterElement({
            key: "refs.refId",
            operation: PageFilterOperationEnum.EQUAL,
            value: ref.refId
          }),
          new PageFilterElement({
            key: "refs.refType",
            operation: PageFilterOperationEnum.EQUAL,
            value: ref.refType
          })
        );
      });
    }

    this.localStore.setFilters(filters);
  }

  get partner() {
    return PartnerModule.partner;
  }

  get controlElements(): IControlElements[] {
    return [
      {
        icon: "mdi-open-in-new",
        text: this.$t("sign.DocumentTable.open").toString(),
        action: this.open
      },
      {
        icon: "mdi-inbox",
        text: this.$t("common.verbs.archive").toString(),
        action: () => (this.isDeleteDialogActive = true)
      }
    ];
  }

  async open(doc: IPartnerMessage) {
    this.$log.info(doc);
    this.selectedDocument = null;
    this.$nextTick(() => {
      doc.fetch();
      this.selectedDocument = doc;
    });
  }

  async deleteDocument(doc: IPartnerMessage) {
    await doc.archive();
  }

  get contactMailto() {
    const inbox = this.partner.settings?.inboxes.find(i => i.isActive && i.source === "email")?.identifier;

    const reportRef = this.refs?.find(r => r.refType === BackendResourceEnum.REPORT);
    if (inbox && reportRef) {
      const [partner, domain] = inbox.split("@");

      let mail = `${partner}`;
      mail += `+${reportRef.refId}`;

      mail += `@${domain}`;

      return mail;
    }

    return undefined;
  }
}
